var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefreshMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4722 10.3016C17.211 10.2562 16.9424 10.3163 16.7255 10.4688C16.5086 10.6213 16.3611 10.8538 16.3156 11.115C16.0561 12.6056 15.2781 13.9566 14.1191 14.9292C12.96 15.9017 11.4945 16.4333 9.98141 16.43C6.43641 16.43 3.55225 13.5458 3.55225 9.99997C3.55225 6.45497 6.43641 3.57081 9.98141 3.57081C11.5931 3.57081 13.1089 4.16581 14.2939 5.24081L13.4672 6.06747C13.3591 6.17521 13.283 6.31084 13.2473 6.45927C13.2116 6.6077 13.2179 6.76312 13.2653 6.90822C13.3127 7.05332 13.3995 7.18243 13.5159 7.28116C13.6323 7.3799 13.7738 7.44439 13.9247 7.46747L17.4347 8.00914C17.563 8.02891 17.6941 8.01815 17.8173 7.97775C17.9406 7.93735 18.0527 7.86844 18.1443 7.77662C18.236 7.6848 18.3047 7.57265 18.3449 7.44929C18.385 7.32593 18.3956 7.19483 18.3756 7.06664L17.8347 3.55747C17.8115 3.40668 17.7469 3.26526 17.6482 3.14893C17.5495 3.03259 17.4205 2.94587 17.2755 2.8984C17.1305 2.85093 16.9752 2.84456 16.8268 2.87999C16.6784 2.91542 16.5427 2.99128 16.4347 3.09914L15.7081 3.82664C14.155 2.37465 12.1075 1.56813 9.98141 1.57081C5.33391 1.57081 1.55225 5.35247 1.55225 9.99997C1.55225 14.6483 5.33391 18.4291 9.98141 18.4291C14.0881 18.4291 17.5797 15.4975 18.2856 11.4583C18.3311 11.1971 18.2709 10.9285 18.1184 10.7116C17.9659 10.4947 17.7335 10.3472 17.4722 10.3016",
    fill: "#989BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefreshMono);
export default __webpack_public_path__ + "static/media/icon-refresh-mono.0d1e4e71fef31cf7b31300123392fbd4.svg";
export { ForwardRef as ReactComponent };